import * as React from "react";
import { useEffect } from 'react';
import { useParams } from "react-router-dom";
import { useAppSelector } from "../store/index";
import { selectPoi } from "../reducers/poi";
import { Helmet } from "react-helmet-async";
import { RootState } from "../reducers/index";
import { PoiSearch } from "../api/poisearch";
import PoiListLoading from "./poilistloading";
import PoiDetails from "./poidetails";
import AdthrivePoiList from "./adthrivepoilist";
import MetaDataPio from "./metadatapoi";

type PoiParams = {
    poiId: string;
}

const RightPoi = () => {
    const { poiId } = useParams<PoiParams>();
    const poiList = useAppSelector<Array<PoiSearch>>((x: RootState) => x.poi.list);
    const poiData = useAppSelector<PoiSearch>((x: RootState) => selectPoi(x, poiId));


    if (poiList.length == 0) {
        return <PoiListLoading />
    }
    if (!poiData) {
        return (
            <div >
                <h3>Poi not found: {poiId}</h3>
                <Helmet>
                    <meta name="robots" content="noindex" />
                </Helmet>
            </div>
        );
    }

    // could pass in as param?
    const ad = <AdthrivePoiList />;

    return (
        <div >
            <PoiDetails poiData={poiData} />
            {ad}
            <MetaDataPio poiData={poiData} />
        </div>
    );
}

export default RightPoi;

